import { NumberedList } from '@/pages/AnalysisResult/components';

import { toNumberedListItems, type RawTitleDescription } from '../lib';
import { useTranslation } from 'react-i18next';

interface SubculturesAndCommunitiesProps {
  subcultures?: RawTitleDescription[];
}

export const SubculturesAndCommunities = ({ subcultures }: SubculturesAndCommunitiesProps) => {
  const { t } = useTranslation('analysis');

  const items = toNumberedListItems(subcultures);

  if (!items.length) return null;

  return (
    <NumberedList
      title={t('analysisResult.subculturesAndCommunities.subCulturesCommunities')}
      subtitle={t(
        'analysisResult.subculturesAndCommunities.behaviouralGroupsThatCutAcrossTheCoreSegments',
      )}
      items={items}
    />
  );
};
